import { Pipe, PipeTransform } from '@angular/core';
import { IBellNotification } from '@app/services/notifications-bell/models/notifcations-bell-models';

@Pipe({
	name: 'filterCurrentOrganizations',
})
export class FilterCurrentOrganizationsPipe implements PipeTransform {
	transform(notifications: IBellNotification[], currentOrgId: number | string, filter: boolean): IBellNotification[] {
		if (filter) {
			return notifications.filter((notification: IBellNotification) => {
				return notification.org_id === currentOrgId;
			});
		}
		return notifications;
	}
}
